import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../../Providers/AuthProvider";
import { GetPackage } from "../../services/GetPackageService";
import { useFormik } from "formik";
import * as Yup from "yup";
import DifinitionForm from "../DifinitionForm/DifinitionForm";
import ConvertDate from "../../common/ConvertDate";
import updateSupplierPackages from "../../services/updateDefinitionPackage";
import { toast } from "react-toastify";
import "animate.css";
import TrackVisibility from "react-on-screen";
import ContentLoading from "../Loading/Loading";
import { useQuery } from "@tanstack/react-query";
import { getAllCitiesService } from "../../services/GetAllCitiesService";
import { goToTop } from "../../utiles/GotoTop";

const ManageTourFirstStep = ({ nextStepTab }) => {
  let params = useParams();

  const [submitTracker, setSubmitTracker] = useState(0);
  const [stepFlag, setStepFlag] = useState(false);
  const nextStepFlag = (flag) => {
    setStepFlag(flag);
  };
  const [tour, setTour] = useState(null);
  const [error, setError] = useState(null);
  const { stateAuth } = useAuth();
  const [loading, setLoading] = useState(true);
  const [initialValues, setInitialValues] = useState();
  // const [searchParams, setSearchParams] = useSearchParams();
  // const id = searchParams.get("id");
  // console.log(id);
  const {
    data: cities,
    isLoading,
    isSuccess: isCitySuccess,
  } = useQuery(
    ["cities"],
    () =>
      getAllCitiesService({
        headers: {
          token: stateAuth,
        },
      }),
    {
      refetchOnMount: false,
    }
  );

  useEffect(() => {
    const requestData = {
      PackageId: params.id,
    };
    if (isCitySuccess) {
      const GetPackageItem = async () => {
        const header = {
          headers: {
            token: stateAuth,
          },
        };
        try {
          const { data } = await GetPackage(requestData, header);
          setTour({
            PackageId: data.Value.Id,
            packageName: data.Value.PackageTitle,
            packageType: 0,
            FloatingCompanyId: data.Value.FloatingCompanyId,
            PackageRule:
              data.Value.PackageRulesBR &&
              data.Value.PackageRulesBR !== "True" &&
              data.Value.PackageRulesBR !== "False"
                ? decodeURIComponent(
                    escape(window.atob(data.Value.PackageRulesBR))
                  )
                : data.Value.PackageRulesBR,
            PackagePublishState: data.Value.PackagePublishState,
            PackageStartDate: ConvertDate(
              data.Value.PackageStartDate.slice(6, 19)
            ).props.children,
            PackageFinishDate: ConvertDate(
              data.Value.PackageFinishDate.slice(6, 19)
            ).props.children,
            PackageSources: cities?.data?.filter((item) =>
              data.Value.PackageSources.split(",").includes(item.Id)
            ),
            PackageDestinations: cities?.data?.filter((item) =>
              data.Value.PackageDestinations.split(",").includes(item.Id)
            ),
          });
          setLoading(false);
          formik.resetForm();
        } catch (error) {
          console.log(error);
        }
      };
      GetPackageItem();
    }
  }, [submitTracker, cities]);

  /*************** formik **************/
  const packageNameOptions = [{ value: "Hiking", label: "طبیعت‌گردی" }];
  // const PackageRuleOptions = [
  //   { value: 1, label: "ندارد" },
  //   { value: 0, label: "دارد" },
  // ];
  const PackagePublishOptions = [
    { value: 1, label: "ندارد" },
    { value: 0, label: "دارد" },
  ];

  useEffect(() => {
    if (tour) {
      setInitialValues({
        packageName: tour.packageName,
        packageType: packageNameOptions[tour.packageType],
        PackagePublishState: tour.PackagePublishState
          ? PackagePublishOptions[1]
          : PackagePublishOptions[0],
        PackageStartDate: tour.PackageStartDate,
        PackageFinishDate: tour.PackageFinishDate,
        PackageSources: tour?.PackageSources?.map((item) => ({
          label: item.City_Persian,
          value: item.Id,
        })),
        PackageDestinations: tour?.PackageDestinations?.map((item) => ({
          label: item.City_Persian,
          value: item.Id,
        })),
        PackageRule: tour.PackageRule,
      });
    }
  }, [tour]);
  const validationSchema = Yup.object({
    packageName: Yup.string()
      .required("لطفا نام تور را وارد نمایید.")
      .min(6, "نام تور حداقل باید شامل شش کارکتر باشد."),
    packageType: Yup.object().required("لطفا نوع تور را انتخاب نمایید."),
    PackagePublishState: Yup.object().required(
      "لطفا قابلیت رزرو تور خود را مشخص کنید."
    ),
    PackageStartDate: Yup.string().required(
      "لطفا تاریخ شروع برگزاری تور خود را وارد نمایید."
    ),
    PackageFinishDate: Yup.string().required(
      "لطفا تاریخ پایان برگزاری تور خود را وارد نمایید."
    ),
    PackageSources: Yup.array().required("لطفا مبدا تور خود را وارد نمایید."),
    PackageDestinations: Yup.array().required(
      "لطفا مقصد تور خود را وارد نمایید."
    ),
  });

  const onSubmit = async (values) => {
    const {
      packageName,
      packageType,
      PackageRule,
      PackagePublishState,
      PackageStartDate,
      PackageFinishDate,
      PackageSources,
      PackageDestinations,
    } = values;
    const userData = {
      packageName,
      packageType: packageType.value,
      FloatingCompanyId: tour.FloatingCompanyId,
      PackageRule: btoa(unescape(encodeURIComponent(PackageRule))),
      PackagePublishState: PackagePublishState.value,
      PackageStartDate,
      PackageFinishDate,
      PackageSources: PackageSources.map((item) => item.value).toString(),
      PackageDestinations: PackageDestinations.map(
        (item) => item.value
      ).toString(),
      PackageState: 0,
      PackageTourLeader: "",
      PackageId: tour.PackageId,
    };
    try {
      const header = {
        headers: {
          token: stateAuth,
        },
      };
      const { data } = await updateSupplierPackages(userData, header);
      setSubmitTracker(submitTracker + 1);
      if (stepFlag) {
        nextStepTab();
      }
      setLoading(true);
      toast.success(`تور ${tour.packageName} بروزرسانی شد.`);
      formik.resetForm();
      goToTop();
    } catch (error) {
      if (error.response && error.response.data.message) {
        setError(error.response.data.message);
        toast.error(error);
        goToTop();
      }
    }
  };

  const formik = useFormik({
    initialValues: initialValues || {
      packageName: "",
      packageType: "",
      PackageRule: "",
      PackageStartDate: "",
      PackageFinishDate: "",
      PackageSources: "",
      PackageDestinations: "",
    },
    onSubmit,
    validationSchema,
    validateOnMount: true,
    enableReinitialize: true,
  });
  return !loading ? (
    <TrackVisibility once>
      {({ isVisible }) =>
        isVisible && (
          <form
            className="flex flex-wrap justify-start animate__animated animate__fadeIn"
            onSubmit={formik.handleSubmit}
          >
            <DifinitionForm
              formik={formik}
              packageNameOptions={packageNameOptions}
              PackagePublishOptions={PackagePublishOptions}
              nextStepFlag={nextStepFlag}
              PackageRuleValue={initialValues.PackageRule}
            />
            {error && <p style={{ color: "red" }}>{error}</p>}
          </form>
        )
      }
    </TrackVisibility>
  ) : (
    <ContentLoading />
  );
};

export default ManageTourFirstStep;
